export default {
  email_form: {
    emailAddress: 'Please enter your email address',
    emailAddressValid: 'Please ensure you enter a valid email address',
    notFound: 'broke'
  },
  stp1: {
    currentlyWorking: `Please tell us if you are currently working in a food store for Co-operative Group Limited`,
    endDate:
    `Please tell us when your employment ended at Co-operative Group Limited (DD/MM/YYYY format)`,
    endDateFuture:
    'Your end date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    moreThanSixYears:
    `Unfortunately, to bring a claim against Co-operative Group Limited you must have worked at in a food store for Co-operative Group Limited within the last 6 years (if you work in England or Wales, or 5 years if you work in Scotland).`,
    storeDetails: `Please provide your store number and name`,
    hourlyWage: `Are/were you paid an hourly wage?`,
    hourlyWageFalse: 'You must have been paid on an hourly wage to continue with the claim'
  },
  stp2: {
    postcode: 'Please enter your postcode',
    postcodeValid: 'Please ensure your postcode is correct',
    houseNumName: 'Please provide the house name or number',
    streetRoad: 'Please enter name of the street you live on',
    townCity: 'Please provide your Town/City',
    country: 'Please provide your Country',
    countryValid: 'You must live in England, Scotland or Wales to be included in the claim'
  },
  stp3: {
    title: 'Please select a title',
    firstName: 'Please enter your first name',
    lastName: 'Please enter your last name',

    emailAddress: 'Please enter your email address',
    emailAddressValid: 'Please ensure you enter a valid email address',

    contactNo: 'Please enter your contact number',
    contactNoValid: 'Please enter a valid contact number',

    dob: 'Please enter your date of birth',
    dobValid: 'You must be at least 18 years old to submit a claim',

    gender: 'Please select the gender that most closely aligns with you',

    nationalInsurance: 'Please enter a valid NI number or leave blank'
  },
  stp4: {
    agree: ''
  },
  util: {
    lettersOnly: 'Please use letters only and no spaces',
    lettersAndSpacesOnly: 'Please use letters only'
  }
};
